





































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import KodingIcd from "@/services/KodingIcd";
import {
  KodingDetail,
  KodingDiagnosisRow,
  KodingLogPerubahan,
  KodingLogRow,
  KodingProsedurRow,
  KodingVerifikasi
} from "@/types/kodingIcd";

const VERIFIKASI_KOSONG: KodingVerifikasi = {
  verified: false,
  user_id: null,
  nama: null,
  waktu: null
};

const CATATAN_MAKS = 2000;

@Component
export default class DialogKodingIcd extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop() readonly register!: string | number | null;

  loading = false;
  saving = false;
  detail: KodingDetail | null = null;

  diagnosis: KodingDiagnosisRow[] = [];
  prosedur: KodingProsedurRow[] = [];
  catatan: string | null = null;
  verifikasi = false;

  log: KodingLogRow[] = [];
  logLoading = false;

  daftarDiagnosa: Array<any> = [];
  daftarProsedur: Array<any> = [];
  pilihDiagnosa: any = null;
  pilihProsedur: any = null;
  cariDiagnosa: string | null = null;
  cariProsedur: string | null = null;
  cariDiagnosaLoading = false;
  cariProsedurLoading = false;

  private timerDiagnosa: any = null;
  private timerProsedur: any = null;

  get labelKategori(): string {
    if (!this.detail) return "";

    return this.detail.kategori === "ranap" ? "Rawat Inap" : "Rawat Jalan";
  }

  get namaPenggunaAktif(): string {
    if (this.detail && this.detail.koder_aktif && this.detail.koder_aktif.nama) {
      return this.detail.koder_aktif.nama;
    }

    const user = userModule.user;

    return user && user.nama ? user.nama : "(pengguna aktif)";
  }

  get labelKoder(): string {
    if (this.detail && this.detail.koder && this.detail.koder.nama) {
      const koder = this.detail.koder;

      return koder.waktu ? `${koder.nama} (${koder.waktu})` : koder.nama;
    }

    return this.namaPenggunaAktif;
  }

  get hintKoder(): string | null {
    if (!this.detail || !this.detail.koder || !this.detail.koder.nama) {
      return null;
    }

    if (
      this.detail.koder_aktif &&
      this.detail.koder.id === this.detail.koder_aktif.id
    ) {
      return null;
    }

    return (
      `Mengubah isi koding memindahkan penginput ke ${this.namaPenggunaAktif}; ` +
      "mencentang verifikasi tidak mengubahnya."
    );
  }

  get infoVerifikasi(): KodingVerifikasi {
    if (this.detail && this.detail.verifikasi) {
      return this.detail.verifikasi;
    }

    return VERIFIKASI_KOSONG;
  }

  get aturanCatatan() {
    return [
      (v: string | null) =>
        !v ||
        v.length <= CATATAN_MAKS ||
        `Catatan maksimal ${CATATAN_MAKS} karakter`
    ];
  }

  get catatanTerlaluPanjang(): boolean {
    return !!this.catatan && this.catatan.length > CATATAN_MAKS;
  }

  @Watch("value")
  onBuka(val: boolean) {
    if (val) this.muat();
  }

  async muat() {
    const reg = this.register;

    this.detail = null;
    this.diagnosis = [];
    this.prosedur = [];
    this.catatan = null;
    this.verifikasi = false;
    this.log = [];
    this.resetPilihanDiagnosa();
    this.resetPilihanProsedur();

    if (!reg) return;

    this.loading = true;

    try {
      const detail = await KodingIcd.getDetail(reg).catch(() => null);

      // Register bisa berganti selagi request berjalan.
      if (String(reg) !== String(this.register)) return;

      this.detail = detail;

      if (detail) {
        this.diagnosis = (detail.diagnosis || []).map(d => ({
          kode: d.kode,
          nama: d.nama,
          kasus: d.kasus
        }));
        this.prosedur = (detail.prosedur || []).map(p => ({
          kode: p.kode,
          nama: p.nama
        }));
        this.catatan = detail.catatan;
        this.verifikasi = !!(detail.verifikasi && detail.verifikasi.verified);
      }
    } finally {
      this.loading = false;
    }

    this.muatLog(reg);
  }

  async muatLog(reg: string | number) {
    this.logLoading = true;

    try {
      const log = await KodingIcd.getLog(reg).catch(() => [] as KodingLogRow[]);

      if (String(reg) !== String(this.register)) return;

      this.log = log;
    } finally {
      this.logLoading = false;
    }
  }

  ringkasPerubahan(ubah: KodingLogPerubahan): string {
    if (ubah.jenis === "catatan") {
      return "Catatan koding diperbarui";
    }

    if (ubah.jenis === "verifikasi") {
      if (ubah.aksi !== "tambah") {
        return "Verifikasi rekam medis dicabut";
      }

      return ubah.nama
        ? `Rekam medis diverifikasi oleh ${ubah.nama}`
        : "Rekam medis diverifikasi";
    }

    const jenis = ubah.jenis === "diagnosis" ? "Diagnosa" : "Prosedur";
    const aksi =
      ubah.aksi === "tambah"
        ? "ditambah"
        : ubah.aksi === "hapus"
        ? "dihapus"
        : "diubah";

    return `${jenis} ${ubah.kode} — ${ubah.nama || "-"} ${aksi}`;
  }

  @Watch("cariDiagnosa")
  onCariDiagnosa(val: string) {
    clearTimeout(this.timerDiagnosa);
    this.timerDiagnosa = setTimeout(() => {
      if (!val || val.length < 2) return;
      this.cariReferensi(
        "/referensi/diagnosis-icd/search",
        val,
        "daftarDiagnosa",
        "cariDiagnosaLoading"
      );
    }, 500);
  }

  @Watch("cariProsedur")
  onCariProsedur(val: string) {
    clearTimeout(this.timerProsedur);
    this.timerProsedur = setTimeout(() => {
      if (!val || val.length < 2) return;
      this.cariReferensi(
        "/referensi/prosedur-icd/search",
        val,
        "daftarProsedur",
        "cariProsedurLoading"
      );
    }, 500);
  }

  cariReferensi(url: string, term: string, target: string, flag: string) {
    (this as any)[flag] = true;

    http
      .getDataParam(url, { params: { term } })
      .then(res => {
        (this as any)[target] = res.data;
      })
      .catch(() => undefined)
      .finally(() => {
        (this as any)[flag] = false;
      });
  }

  tambahDiagnosa(item: any) {
    if (!item) return;

    const kode = item.kddx;

    if (!this.diagnosis.some(d => d.kode === kode)) {
      this.diagnosis.push({ kode, nama: item.dx, kasus: null });
    }

    this.resetPilihanDiagnosa();
  }

  tambahProsedur(item: any) {
    if (!item) return;

    const kode = item.kode;

    if (!this.prosedur.some(p => p.kode === kode)) {
      this.prosedur.push({ kode, nama: item.tindakan });
    }

    this.resetPilihanProsedur();
  }

  hapusDiagnosa(index: number) {
    this.diagnosis.splice(index, 1);
  }

  hapusProsedur(index: number) {
    this.prosedur.splice(index, 1);
  }

  resetPilihanDiagnosa() {
    this.$nextTick(() => {
      this.pilihDiagnosa = null;
      this.cariDiagnosa = null;
      this.daftarDiagnosa = [];
    });
  }

  resetPilihanProsedur() {
    this.$nextTick(() => {
      this.pilihProsedur = null;
      this.cariProsedur = null;
      this.daftarProsedur = [];
    });
  }

  async simpan() {
    if (!this.detail || this.saving) return;

    if (this.catatanTerlaluPanjang) {
      appModule.NoticeDelay(
        `Catatan koding maksimal ${CATATAN_MAKS} karakter`
      );

      return;
    }

    this.saving = true;

    try {
      // `unit_id` / `dr_id` / `episode` sengaja tidak dikirim — server
      // menurunkannya dari register.
      const body = await KodingIcd.simpan(this.detail.register_id, {
        diagnosis: this.diagnosis.map(d => ({
          kode: d.kode,
          kasus: d.kasus || null
        })),
        prosedur: this.prosedur.map(p => ({ kode: p.kode })),
        catatan:
          this.catatan && this.catatan.trim() !== "" ? this.catatan : null,
        verifikasi: this.verifikasi
      }).catch(() => null);

      if (!body || String(body.status) !== "1") {
        return;
      }

      appModule.NoticeDelay("Koding ICD berhasil disimpan");

      this.$emit("tersimpan", this.detail.register_id);
      this.$emit("input", false);
    } finally {
      this.saving = false;
    }
  }

  tutup() {
    this.$emit("input", false);
  }
}
